import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from 'react-animated-css';

import StationSelector from '../../components/dashboard/StationSelector';
import DevicesTable from '../../components/devices/DevicesTable';
import SummaryButtons from '../../components/devices/SummaryButtons';

import './Devices.css';
import { initializeStation } from '../../utils/initStation';
import {
  getUserStationList,
  inspectionTimeUpdate
} from '../../modules/analytics';

class Devices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await initializeStation(this.props);
    this.setState({ loading: false });
  }



  render() {
    const { inspectionTime, stationSummary = {} } = this.props;
    const summary = stationSummary[inspectionTime.stationId] || {};
    const { devices = 0, onlineDevices = 0 } = summary;

    return (
      <Animated animationIn="fadeIn">
        <div className="devicesWrapper" style={{ paddingBottom: this.props.play ? '100px' : '20px' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={17} className="leftPanel">
              <StationSelector pageTitle="Devices" />
              <SummaryButtons devices={devices} onlineDevices={onlineDevices} />
            </Col>
          </Row>
          <DevicesTable stationId={inspectionTime.stationId} />
        </div>
      </Animated>
    );
  }
}

const mapStateToProps = (state) => ({
  router: state.router,
  userProfile: state.user.userProfile,
  userStationList: state.analytics.userStationList,
  inspectionTime: state.analytics.inspectionTime,
  stationSummary: state.analytics.stationSummary,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserStationList,
      inspectionTimeUpdate,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Devices);
